import { useEffect } from 'react';
import { useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  // Only force a top scroll on an actual forward navigation (PUSH/REPLACE) to this page.
  // On POP (browser/in-app back or forward button) the browser already restores the scroll
  // position this page had before the user left it — forcing scrollTo(0) here fought that
  // restoration, landing back navigation on top of the page instead of where the user was.
  // const navigationType = useNavigationType();

  useEffect(() => {
    // if (navigationType === 'POP') return;
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 0);
  }, []);

  return null;
};

export default ScrollToTop;
